"use strict";

require("core-js/modules/es6.function.name");

var _regeneratorRuntime = require("/builds/godoo/frontend/website/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es6.array.map");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _propTypes = _interopRequireDefault(require("prop-types")),
    _downshift = _interopRequireDefault(require("downshift")),
    _antd = require("antd"),
    _hooks = require("./hooks"),
    _DropdownRelationships = _interopRequireDefault(require("./DropdownRelationships")),
    S = _interopRequireWildcard(require("./styles"));

require("./styles.css");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    "default": a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c["default"] = a, b && b.set(a, c), c;
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

function asyncGeneratorStep(a, b, c, d, e, f, g) {
  try {
    var h = a[f](g),
        i = h.value;
  } catch (a) {
    return void c(a);
  }

  h.done ? b(i) : Promise.resolve(i).then(d, e);
}

function _asyncToGenerator(a) {
  return function () {
    var b = this,
        c = arguments;
    return new Promise(function (d, e) {
      function f(a) {
        asyncGeneratorStep(h, d, e, f, g, "next", a);
      }

      function g(a) {
        asyncGeneratorStep(h, d, e, f, g, "throw", a);
      }

      var h = a.apply(b, c);
      f(void 0);
    });
  };
}

function _slicedToArray(a, b) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, b) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(a, b) {
  if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) {
    var c = [],
        d = !0,
        e = !1,
        f = void 0;

    try {
      for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
        ;
      }
    } catch (a) {
      e = !0, f = a;
    } finally {
      try {
        d || null == h["return"] || h["return"]();
      } finally {
        if (e) throw f;
      }
    }

    return c;
  }
}

function _arrayWithHoles(a) {
  if (Array.isArray(a)) return a;
}

function _toConsumableArray(a) {
  return _arrayWithoutHoles(a) || _iterableToArray(a) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(a) {
  if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) return Array.from(a);
}

function _arrayWithoutHoles(a) {
  if (Array.isArray(a)) {
    for (var b = 0, c = Array(a.length); b < a.length; b++) {
      c[b] = a[b];
    }

    return c;
  }
}

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

function objToString(a) {
  return null == a ? "" : "string" == typeof a ? a : a.hasOwnProperty("value") ? a.value : a; // eslint-disable-next-line no-prototype-builtins
}

var removeLastAsterisk = function removeLastAsterisk(a) {
  var b = objToString(a);
  return "*" === b.charAt(b.length - 1) ? b.substring(0, b.length - 1) : b;
},
    hasFirstParam = function hasFirstParam(a) {
  return a.includes("?");
},
    concatParam = function concatParam(a, b, c) {
  if (null == c || "" === c) return a;
  var d = hasFirstParam(a) ? "&" : "?"; // concat char

  return "".concat(a).concat(d).concat(b, "=").concat(c);
};

function concatPathVal(a, b) {
  return null == b ? a : "".concat(a, "/").concat(b);
}

var Suggestions = function Suggestions(a) {
  var b = a.isOpen,
      c = a.isLoading,
      d = a.selectedItem,
      e = a.inputValue,
      f = a.suggestions,
      g = a.highlightedIndex,
      h = a.setSuggestionsIndex,
      i = a.setSearchValue,
      j = a.getItemProps,
      k = a.isForInsert,
      l = a.forInsertText,
      m = a.noDataText,
      n = a.setShowRel,
      o = a.disabled;
  if (c) return _react["default"].createElement(_antd.Menu.Item, _extends({}, a, {
    disabled: !0
  }), "Loading...");
  if (!b) return n(b), null;
  if (i(e), !f) return null;

  var p = function p() {
    return _react["default"].createElement("div", {
      id: "suggestionsFixedBottom"
    }, _react["default"].createElement(_antd.Menu.Item, _extends({}, a, j({
      key: {
        value: e
      },
      index: f.length,
      item: {
        value: e
      },
      style: {
        color: "black",
        backgroundColor: g === f.length ? "#e6f7ff" : "white"
      }
    })), "".concat(l, " ").concat(e)));
  };

  if (0 < f.length) {
    h(g);
    var q = f.map(function (b, c) {
      return _react["default"].createElement(_antd.Menu.Item, _extends({}, a, j({
        key: JSON.stringify(b),
        index: c,
        item: b,
        style: {
          color: "black",
          backgroundColor: g === c ? "#e6f7ff" : "white",
          fontWeight: d === b ? "bold" : "normal"
        }
      }), {
        key: JSON.stringify(b),
        disabled: o
      }), b.value);
    });
    return [_react["default"].createElement(S.SuggestionsWrapper, {
      items: f.length
    }, q)].concat(_toConsumableArray(k && "" !== e ? [_react["default"].createElement(p, null)] : []));
  }

  return 0 === f.length ? (n(!1), [_react["default"].createElement(S.SuggestionsWrapper, null, 0 < e.length ? _react["default"].createElement(_antd.Menu.Item, _extends({}, a, {
    disabled: !0
  }), m) : null)].concat(_toConsumableArray(k && "" !== e ? [_react["default"].createElement(p, null)] : []))) : null;
},
    SearchBar = function SearchBar(a) {
  function b() {
    return c.apply(this, arguments);
  }

  function c() {
    return c = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function a(b) {
      var c;
      return _regeneratorRuntime.wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return G(!0), a.next = 3, f(b);

            case 3:
              c = a.sent, G(!1), y(c);

            case 6:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), c.apply(this, arguments);
  }

  var d = a.placeholder,
      f = a.getSuggestions,
      g = a.disabled,
      h = a.isForInsert,
      i = a.forInsertText,
      j = a.noDataText,
      k = a.name,
      l = a.value,
      m = a.setFieldValue,
      n = a.setFieldTouched,
      o = a.multipleValueSearch,
      p = a.searchBaseUrlForRelationships,
      q = a.relationshipsResource,
      r = (0, _react.useState)(null),
      s = _slicedToArray(r, 2),
      t = s[0],
      u = s[1],
      v = (0, _react.useState)([]),
      w = _slicedToArray(v, 2),
      x = w[0],
      y = w[1],
      z = (0, _react.useState)(!0),
      A = _slicedToArray(z, 2),
      B = A[0],
      C = A[1],
      D = (0, _react.useState)(!1),
      E = _slicedToArray(D, 2),
      F = E[0],
      G = E[1],
      H = (0, _react.useState)(-1),
      I = _slicedToArray(H, 2),
      J = I[0],
      K = I[1],
      L = (0, _react.useState)(!1),
      M = _slicedToArray(L, 2),
      N = M[0],
      O = M[1],
      P = (0, _react.useState)(""),
      Q = _slicedToArray(P, 2),
      R = Q[0],
      T = Q[1],
      U = (0, _hooks.useGet)(),
      V = _slicedToArray(U, 2),
      W = V[0],
      X = W.data,
      Y = W.isLoading,
      Z = V[1],
      $ = (0, _hooks.useDebounce)(t, 500),
      _ = (0, _hooks.useDebounceInt)(J, 600),
      aa = (0, _react.useRef)(null),
      ba = _react["default"].createRef();

  (0, _react.useEffect)(function () {
    T(removeLastAsterisk(l));
  }, [l]), (0, _react.useEffect)(function () {
    if (!(null == J || -1 === J || J >= x.length)) {
      var a = p;
      a = concatPathVal(a, q), a = concatParam(a, "key", x[J].key), Z(a);
    }
  }, [_]), (0, _react.useEffect)(function () {
    return null == X ? void O(!1) : void O(x && 0 < x.length && (X.exceptions && 0 < X.exceptions.length || X.attributes && 0 < X.attributes.length || X.dynamicUsages && 0 < X.dynamicUsages.length || X.staticUsages && 0 < X.staticUsages.length) || X.enumerations && 0 < X.enumerations.length || X.billingItem);
  }, [X]), (0, _react.useEffect)(function () {
    B && ($ ? (C(!0), b($)) : y([]));
  }, [$]);

  var ca = function ca(a) {
    if (h) return void (null != a.currentTarget && "" === a.currentTarget.value && m(k, null));
    var b = a.currentTarget.value;
    o && null != x && 1 !== x.length && "" !== b && (b += "*"), m && m(k, b);
  },
      da = function da(a) {
    "Enter" === a.key && ca(a);
  },
      ea = function ea(a) {
    m && m(k, a);
  },
      fa = function onBlur(a) {
    var b = a.currentTarget;
    setTimeout(function () {
      b.contains(document.activeElement) || ("" === ba.current.props.value && m(k, null), n(k, !0));
    }, 0);
  };

  return _react["default"].createElement(S.SelectSuggestion, {
    onBlur: function onBlur(a) {
      return fa(a);
    }
  }, _react["default"].createElement(_downshift["default"], {
    stateReducer: function stateReducer(a, b) {
      return b.type === _downshift["default"].stateChangeTypes.mouseUp ? _objectSpread({}, b, {
        isOpen: !0,
        inputValue: ba.current.props.value
      }) : (b.type === _downshift["default"].stateChangeTypes.changeInput && (_downshift["default"].defaultProps.inputValue = ba.current.value), b);
    },
    itemToString: function itemToString(a) {
      return objToString(a);
    } // custom implementation of item to string, due to the fact that item is an object
    ,
    onSelect: function onSelect(a) {
      return ea(a);
    },
    inputValue: R,
    onStateChange: function onStateChange(a) {
      a.hasOwnProperty("inputValue") && T(a.inputValue);
    }
  }, function (a) {
    var b = a.getInputProps,
        c = a.getMenuProps,
        e = a.getItemProps,
        f = a.isOpen,
        k = a.selectedItem,
        l = a.highlightedIndex;
    return _react["default"].createElement("div", null, _react["default"].createElement(_antd.Input, _extends({
      className: "form-control",
      ref: ba,
      placeholder: d,
      onKeyPress: da,
      disabled: g,
      value: t
    }, b({
      onChange: function onChange(a) {
        T(a.target.value);
      }
    }))), _react["default"].createElement("div", {
      ref: aa
    }, _react["default"].createElement(_antd.Menu, c(), _react["default"].createElement(Suggestions, {
      isOpen: f,
      isLoading: F,
      selectedItem: k,
      inputValue: R,
      suggestions: x,
      highlightedIndex: l,
      setSuggestionsIndex: K,
      setSearchValue: u,
      getItemProps: e,
      isForInsert: h,
      forInsertText: i,
      noDataText: j,
      setShowRel: O,
      disabled: g
    }))));
  }), N && _react["default"].createElement(S.DropdownRelationshipsWrapper, {
    target: aa.current
  }, _react["default"].createElement(_DropdownRelationships["default"], {
    relationships: X,
    isLoading: Y
  })));
};

SearchBar.defaultProps = {
  placeholder: "Search for...",
  disabled: !1,
  isForInsert: !0,
  forInsertText: "Add translation: ",
  noDataText: "NO DATA AVAILABLE",
  multipleValueSearch: !1,
  value: null,
  relationshipsResource: "relationships",
  searchBaseUrlForRelationships: "https://dev.godoo.ch/v1.0/keys"
}, SearchBar.props = {
  placeholder: _propTypes["default"].string,
  getSuggestions: _propTypes["default"].func.isRequired,
  isForInsert: _propTypes["default"].bool,
  forInsertText: _propTypes["default"].string,
  noDataText: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  name: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].object,
  setFieldValue: _propTypes["default"].func.isRequired,
  setFieldTouched: _propTypes["default"].func,
  error: _propTypes["default"].bool,
  multipleValueSearch: _propTypes["default"].bool,
  relationshipsResource: _propTypes["default"].string,
  searchBaseUrlForRelationships: _propTypes["default"].string
};
var _default = SearchBar;
exports["default"] = _default;